import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray80 } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  height?: number;
  title?: string;
  width?: number;
};

const ItalicIcon = ({
  className = '',
  color = bdlGray80,
  height = 16,
  title,
  width = 16,
}: Props) => (
  <AccessibleSVG
    className={className}
    height={height}
    title={title}
    viewBox="0 0 16 16"
    width={width}
  >
    <path
      d="M8.15039 5.25L8.27453 5.25783C8.78341 5.32144 9.15493 5.75692 9.15039 6.25L9.14277 6.37414L8.14277 14.3741C8.07427 14.9222 7.57448 15.3109 7.02646 15.2424C6.51759 15.1788 6.14606 14.7433 6.15039 14.25L6.15822 14.1261L7.15822 6.12607C7.22183 5.61719 7.65731 5.24567 8.15039 5.25Z"
      fill={color}
    />
    <circle cx="8.59961" cy="3" fill={color} r="1.25" />
  </AccessibleSVG>
);

export default ItalicIcon;
